import { render, staticRenderFns } from "./IconPinLocation.vue?vue&type=template&id=62055d76&"
import script from "./IconPinLocation.vue?vue&type=script&lang=js&"
export * from "./IconPinLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports